export const getIconCategoryMobi = (key: string, className?: string) => {
  switch (key) {
    case 'SIMSO':
      return (
        <svg
          className={className}
          width="58"
          height="58"
          viewBox="0 0 58 58"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint0_linear_430_4767)"
          />
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint1_linear_430_4767)"
          />
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint2_linear_430_4767)"
          />
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint3_linear_430_4767)"
          />
          <path
            d="M41.5667 19.8997L36.45 14.783C34.8833 13.2163 32.7667 12.333 30.55 12.333H22.3333C17.3333 12.333 14 15.6663 14 20.6663V37.333C14 42.333 17.3333 45.6663 22.3333 45.6663H35.6667C40.6667 45.6663 44 42.333 44 37.333V25.783C44 23.5663 43.1167 21.4497 41.5667 19.8997V19.8997Z"
            fill="white"
          />
          <path
            d="M28.167 31.083V24.833H25.667C22.917 24.833 20.667 27.083 20.667 29.833V31.4997H27.7503C27.9837 31.4997 28.167 31.3163 28.167 31.083Z"
            fill="url(#paint4_linear_430_4767)"
          />
          <path
            d="M30.2497 31.4997H37.333V29.833C37.333 27.083 35.083 24.833 32.333 24.833H29.833V31.083C29.833 31.3163 30.0163 31.4997 30.2497 31.4997Z"
            fill="url(#paint5_linear_430_4767)"
          />
          <path
            d="M27.7503 33.166H20.667V34.8327C20.667 37.5827 22.917 39.8327 25.667 39.8327H28.167V33.5827C28.167 33.3493 27.9837 33.166 27.7503 33.166Z"
            fill="url(#paint6_linear_430_4767)"
          />
          <path
            d="M29.833 33.5827V39.8327H32.333C35.083 39.8327 37.333 37.5827 37.333 34.8327V33.166H30.2497C30.0163 33.166 29.833 33.3493 29.833 33.5827Z"
            fill="url(#paint7_linear_430_4767)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_430_4767"
              x1="58"
              y1="58.1409"
              x2="0"
              y2="0.140896"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.166226" stopColor="#2972FE" />
              <stop offset="1" stopColor="#6499FF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_430_4767"
              x1="33.8087"
              y1="57.4226"
              x2="33.2414"
              y2="-2.137"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#F15836" />
              <stop offset="1" stopColor="#FF924F" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_430_4767"
              x1="33.0949"
              y1="58"
              x2="32.7372"
              y2="-1.34732e-06"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFB01F" />
              <stop offset="1" stopColor="#FFCF45" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_430_4767"
              x1="33.0949"
              y1="58"
              x2="32.7372"
              y2="-1.34732e-06"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFB01F" />
              <stop offset="1" stopColor="#FFCF45" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_430_4767"
              x1="20.667"
              y1="28.1663"
              x2="28.167"
              y2="28.1663"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFA500" />
              <stop offset="1" stopColor="#FFBD00" />
            </linearGradient>
            <linearGradient
              id="paint5_linear_430_4767"
              x1="29.833"
              y1="28.1663"
              x2="37.333"
              y2="28.1663"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFA500" />
              <stop offset="1" stopColor="#FFBD00" />
            </linearGradient>
            <linearGradient
              id="paint6_linear_430_4767"
              x1="20.667"
              y1="36.4994"
              x2="28.167"
              y2="36.4994"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFA500" />
              <stop offset="1" stopColor="#FFBD00" />
            </linearGradient>
            <linearGradient
              id="paint7_linear_430_4767"
              x1="29.833"
              y1="36.4994"
              x2="37.333"
              y2="36.4994"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFA500" />
              <stop offset="1" stopColor="#FFBD00" />
            </linearGradient>
          </defs>
        </svg>
      );

    case 'GOICUOC':
      return (
        <svg
          className={className}
          width="58"
          height="58"
          viewBox="0 0 58 58"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint0_linear_430_4857)"
          />
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint1_linear_430_4857)"
          />
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint2_linear_430_4857)"
          />
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint3_linear_430_4857)"
          />
          <path
            d="M0 12C0 5.37258 5.37258 0 12 0H46C52.6274 0 58 5.37258 58 12V58H12C5.37258 58 0 52.6274 0 46V12Z"
            fill="url(#paint4_linear_430_4857)"
          />
          <path
            d="M27.1337 30.8428C24.3884 30.8428 16.3086 30.8428 16.3086 30.8428C15.4509 30.8428 14.749 31.5445 14.749 32.4022V44.1075C14.749 44.9652 15.4509 45.6669 16.3086 45.6669C16.3086 45.6669 24.5575 45.6669 27.3157 45.6669C27.6826 45.6669 27.6826 45.2728 27.6826 45.2728V31.3727C27.6825 31.3727 27.6825 30.8428 27.1337 30.8428Z"
            fill="white"
          />
          <path
            d="M41.6909 30.8428C41.6909 30.8428 33.5802 30.8428 30.8768 30.8428C30.2181 30.8428 30.3168 31.5287 30.3168 31.5287V45.2855C30.3168 45.2855 30.3114 45.6666 30.7076 45.6666C33.4534 45.6666 41.6907 45.6666 41.6907 45.6666C42.5484 45.6666 43.2502 44.9648 43.2502 44.1071V32.4022C43.2505 31.5445 42.5486 30.8428 41.6909 30.8428Z"
            fill="white"
          />
          <path
            d="M27.6829 21.6329C27.6829 21.6329 27.6829 21.1045 27.1607 21.1045C24.0337 21.1045 14.5478 21.1045 14.5478 21.1045C13.6901 21.1045 12.9883 21.8063 12.9883 22.6639V27.532C12.9883 28.3898 13.6901 29.0915 14.5478 29.0915C14.5478 29.0915 24.0762 29.0915 27.2034 29.0915C27.6829 29.0915 27.6829 28.6756 27.6829 28.6756V21.6329Z"
            fill="white"
          />
          <path
            d="M43.4523 21.1045C43.4523 21.1045 33.9626 21.1045 30.7992 21.1045C30.3174 21.1045 30.3174 21.5636 30.3174 21.5636V28.6853C30.3174 28.6853 30.3174 29.0915 30.9032 29.0915C34.0404 29.0915 43.4523 29.0915 43.4523 29.0915C44.31 29.0915 45.0119 28.3898 45.0119 27.532V22.6639C45.0119 21.8063 44.31 21.1045 43.4523 21.1045Z"
            fill="white"
          />
          <path
            d="M22.3786 19.9502C21.6651 19.9502 21.0134 19.8936 20.4418 19.7819C18.9902 19.4983 17.9925 18.9463 17.3917 18.0946C16.8533 17.3313 16.6886 16.3903 16.9019 15.2976C17.2754 13.3858 18.5594 12.333 20.5168 12.333C20.9311 12.333 21.386 12.3808 21.8691 12.4753C23.0981 12.7153 24.6699 13.42 26.0739 14.3602C28.456 15.9556 28.5738 16.9474 28.4552 17.5547C28.2808 18.4471 27.4467 19.0847 25.9052 19.5042C24.8637 19.7876 23.5784 19.9502 22.3786 19.9502ZM20.5169 14.8326C19.7589 14.8326 19.4983 15.0443 19.3553 15.7769C19.2383 16.3758 19.3858 16.5849 19.4342 16.6537C19.6369 16.9411 20.1649 17.1809 20.9211 17.3285C21.3291 17.4082 21.8332 17.4504 22.3785 17.4504C23.5776 17.4504 24.6339 17.2687 25.3348 17.07C25.3858 17.0556 25.465 16.9952 25.3802 16.9447C24.4638 16.1982 22.7873 15.2014 21.3899 14.9283C21.0644 14.8649 20.7705 14.8326 20.5169 14.8326Z"
            fill="white"
          />
          <path
            d="M35.657 19.9501C35.657 19.9501 35.657 19.9501 35.6568 19.9501C34.4571 19.9501 33.1718 19.7875 32.1304 19.5041C30.5887 19.0847 29.7548 18.447 29.5804 17.5547C29.4618 16.9474 29.5794 15.9556 31.9617 14.3602C33.3655 13.42 34.9374 12.7153 36.1665 12.4753C36.6496 12.3808 37.1046 12.333 37.5185 12.333C39.4764 12.333 40.7602 13.3859 41.1335 15.2977C41.347 16.3903 41.1823 17.3313 40.6439 18.0946C40.043 18.9464 39.0454 19.4983 37.5935 19.7819C37.0222 19.8934 36.3705 19.9501 35.657 19.9501ZM32.6754 16.9291C32.5942 16.9762 32.6335 17.0507 32.6756 17.0628C33.3762 17.2643 34.4437 17.4504 35.6568 17.4504C36.2023 17.4504 36.7062 17.4082 37.1143 17.3285C37.8704 17.1808 38.3986 16.9411 38.6012 16.6537C38.6498 16.5849 38.7975 16.3758 38.6802 15.7769C38.5372 15.0443 38.2766 14.8326 37.5184 14.8326C37.2649 14.8326 36.9713 14.8648 36.6455 14.9285C35.248 15.2014 33.5917 16.1825 32.6754 16.9291Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_430_4857"
              x1="58"
              y1="58.1409"
              x2="0"
              y2="0.140896"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0.166226" stopColor="#2972FE" />
              <stop offset="1" stopColor="#6499FF" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_430_4857"
              x1="33.8087"
              y1="57.4226"
              x2="33.2414"
              y2="-2.137"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#F15836" />
              <stop offset="1" stopColor="#FF924F" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_430_4857"
              x1="33.0949"
              y1="58"
              x2="32.7372"
              y2="-1.34732e-06"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFB01F" />
              <stop offset="1" stopColor="#FFCF45" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_430_4857"
              x1="33.0949"
              y1="58"
              x2="32.7372"
              y2="-1.34732e-06"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FFB01F" />
              <stop offset="1" stopColor="#FFCF45" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_430_4857"
              x1="33.8087"
              y1="57.4226"
              x2="33.2414"
              y2="-2.137"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#F15836" />
              <stop offset="1" stopColor="#FF924F" />
            </linearGradient>
          </defs>
        </svg>
      );
    case 'VIETLOTT':
      return (
        <svg
          className={className}
          width="56"
          height="56"
          viewBox="0 0 56 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d_1390_3099)">
            <path
              d="M10.5312 22.2441C10.5312 15.6167 15.9038 10.2441 22.5312 10.2441H33.5312C40.1587 10.2441 45.5312 15.6167 45.5312 22.2441V45.2441H22.5312C15.9038 45.2441 10.5312 39.8716 10.5312 33.2441V22.2441Z"
              fill="url(#paint0_linear_1390_3099)"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.106 22.1519C26.2582 22.787 27.4802 23.0616 28.7721 23.0444C28.9059 23.0444 29.0398 23.0425 29.1736 23.0406C29.4413 23.0368 29.709 23.033 29.9767 23.0444C30.2734 23.0616 30.4306 22.9758 30.5178 22.6668L30.5388 22.5861C30.724 21.8739 30.9127 21.148 31.1987 20.4699C31.5653 19.5774 31.0765 19.1311 30.3084 18.9766C29.1212 18.7192 27.9341 18.702 26.7295 18.805C25.4377 18.9251 24.268 19.4229 23.1332 19.9893C22.8714 20.1266 22.592 20.3326 22.6095 20.6758C22.6251 20.9675 22.8642 21.0807 23.0894 21.1873C23.1159 21.1999 23.1423 21.2124 23.1681 21.2251C23.3835 21.328 23.6007 21.4272 23.818 21.5264C24.2525 21.7247 24.687 21.9231 25.106 22.1519ZM26.8844 23.8666C27.3902 23.8499 27.8599 24.0007 28.2754 24.2521C28.4812 24.3794 28.6839 24.5127 28.886 24.6456L28.8861 24.6457C29.1629 24.8277 29.4387 25.0092 29.7206 25.1738C29.9554 25.3079 29.9916 25.4419 29.9012 25.6766C29.8019 25.9196 29.7161 26.1625 29.6303 26.4055L29.6303 26.4055L29.6303 26.4056L29.6303 26.4056L29.6302 26.4056C29.5444 26.6486 29.4586 26.8916 29.3593 27.1346C29.1064 27.7714 28.7089 28.3077 28.1128 28.7266C26.7985 29.6464 25.4916 30.573 24.1873 31.4977L24.1872 31.4978L24.187 31.4979L24.1869 31.498C23.4476 32.0222 22.7091 32.5458 21.9707 33.0671C21.1397 33.6537 20.5435 33.5531 20.0016 32.732C18.4119 30.3187 18.0144 27.7714 18.9719 25.0565C19.1887 24.4197 19.4777 24.2186 20.2184 24.185C21.3294 24.1348 22.4404 24.0803 23.5514 24.0258C24.6624 23.9714 25.7734 23.9169 26.8844 23.8666ZM28.2115 36.7238H27.8449C26.8324 36.6551 26.5181 36.2089 26.8149 35.2649C26.9776 34.73 27.1418 34.1936 27.3062 33.6566L27.3063 33.6561L27.3065 33.6557L27.3066 33.6552L27.3067 33.6549L27.3067 33.6548C27.7066 32.3488 28.1075 31.0392 28.4908 29.7382C28.84 28.5711 29.4336 27.5928 30.5159 26.9405C30.6402 26.8649 30.7624 26.7637 30.8834 26.6635C31.1192 26.4682 31.35 26.277 31.5809 26.2883C31.8236 26.3003 32.058 26.5114 32.2956 26.7254L32.2956 26.7255L32.2956 26.7255L32.2956 26.7255C32.3998 26.8192 32.5045 26.9136 32.6109 26.992L32.7383 27.0881C32.9173 27.2229 33.087 27.3507 33.2568 27.4898C33.7107 27.8674 34.0599 28.2965 34.2519 28.8629L34.3112 29.0324C34.6583 30.0245 35.0096 31.0286 35.439 31.9866C35.7882 32.7933 35.6136 33.394 35.02 33.9776C33.606 35.3679 31.9126 36.1917 29.9573 36.535C29.5732 36.6036 29.1891 36.6418 28.8051 36.6799C28.613 36.699 28.421 36.7181 28.229 36.7409C28.2202 36.7409 28.2158 36.7409 28.2137 36.7388C28.2115 36.7366 28.2115 36.7323 28.2115 36.7238ZM37.6025 28.2306V28.2307C37.6083 28.5388 37.6146 28.8725 37.5156 29.1889C37.3585 29.6867 37.0966 29.7897 36.6776 29.515C36.0491 29.086 35.4207 28.6569 34.8096 28.2106C34.4081 27.9188 34.1812 27.4726 34.0066 27.0263C33.8704 26.6762 33.7531 26.326 33.6358 25.9759C33.5576 25.7425 33.4794 25.5091 33.3956 25.2756C33.3257 25.0868 33.3956 24.9839 33.5527 24.8637C33.8669 24.6492 34.1812 24.4303 34.4954 24.2115L34.4958 24.2112C34.8099 23.9925 35.124 23.7737 35.4381 23.5593C36.0142 23.1645 36.4157 23.2675 36.7474 23.8682C37.2712 24.8294 37.6029 26.3398 37.6029 27.8673C37.5978 27.9821 37.6001 28.1042 37.6025 28.2306ZM33.6561 23.0405C33.7841 23.0424 33.9121 23.0444 34.0402 23.0444C34.4417 23.0444 34.8432 23.0444 35.2273 23.0615C35.4892 23.0615 35.7161 22.9757 35.8383 22.7354C35.9372 22.5247 35.7871 22.36 35.6525 22.2122C35.6445 22.2035 35.6366 22.1948 35.6288 22.1862C35.0178 21.5168 34.3719 20.9161 33.6386 20.384L33.6386 20.384C33.2895 20.1265 32.9403 19.8691 32.5214 19.7661C31.9452 19.6116 31.6135 19.9206 31.7881 20.487C31.8933 20.8369 32.0059 21.1868 32.1191 21.5384C32.2502 21.9457 32.3821 22.3552 32.5039 22.7697C32.5737 22.9757 32.661 23.0444 32.888 23.0444C33.144 23.0329 33.4001 23.0367 33.6561 23.0405Z"
              fill="white"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_1390_3099"
              x="0.53125"
              y="0.244141"
              width="55"
              height="55"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset />
              <feGaussianBlur stdDeviation="5" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.18 0 0 0 0 0 0 0 0 0.25 0" />
              <feBlend mode="darken" in2="BackgroundImageFix" result="effect1_dropShadow_1390_3099" />
              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1390_3099" result="shape" />
            </filter>
            <linearGradient
              id="paint0_linear_1390_3099"
              x1="28.0312"
              y1="10.2441"
              x2="28.0312"
              y2="45.2441"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF5530" />
              <stop offset="1" stopColor="#FA1515" />
            </linearGradient>
          </defs>
        </svg>
      );
    default:
      return <></>;
  }
};
